import { performLogout } from '../lib/logout'

type Props = {
  /** 侧栏：全宽次要按钮 */
  variant?: 'sidebar' | 'inline'
  className?: string
}

export function LogoutButton({ variant = 'sidebar', className = '' }: Props) {
  const base =
    variant === 'sidebar'
      ? 'w-full rounded-[var(--radius-sm)] border border-line bg-surface px-3 py-2.5 text-left text-sm font-semibold text-ink transition hover:border-[var(--color-error)] hover:bg-surface-muted hover:text-[var(--color-error)]'
      : 'rounded-[var(--radius-sm)] border border-line bg-surface px-4 py-2 text-sm font-semibold text-ink hover:bg-surface-muted'

  return (
    <button
      type="button"
      className={[base, className].filter(Boolean).join(' ')}
      onClick={() => void performLogout()}
    >
      退出登录
    </button>
  )
}
